import { WarehouseElementLocation } from "components/WarehouseElements/WarehouseElementsData";

type Props = {
  id: string;
  name: string;
  shortcutLocation: WarehouseElementLocation;
};

const ShortcutGridElement: React.FC<Props> = ({ id, shortcutLocation }) => {
  return (
    <div
      id={id.toUpperCase()}
      className="shortcut"
      style={{
        gridColumnStart: shortcutLocation.start.x,
        gridColumnEnd: shortcutLocation.end?.x,
        gridRowStart: shortcutLocation.start.y,
        gridRowEnd: shortcutLocation.end?.x,
      }}
    />
  );
};
export default ShortcutGridElement;
